import { Breadcrumb, HomeBreadcrumb } from '@digitools/honest-ui';
import React from 'react';
import useAuthentication from 'src/hooks/useAuthentication';
import useExperience from '../../hooks/useExperience';
import { Experience } from 'src/types/Experience';
import { TEALIUM_EVENT } from 'src/constants/tealiumConstants';
import useTealium from 'src/hooks/useTealium';
import { CustomEmployeeText } from 'src/utils/CustomExperienceText';
import { Language } from 'src/types/Language';
import queryString from 'query-string';
import BreadcrumbText from 'src/packages/status/i18n/BreadcrumbText';
import useTranslate from 'src/hooks/useTranslate';
import { encode } from 'src/packages/status/utilities/hash';
export const useHomePageBreadcrumbs = () => {
    const { trackEvent } = useTealium();
    const { isMultiCustomerUser } = useAuthentication();
    const { experience, language } = useExperience();
    const isEmployer = experience === Experience.EMPLOYER;
    const isHomePage = window.location.pathname.endsWith('/home');
    const customEmployeeText = language === Language.ENGLISH ? `${CustomEmployeeText()} home` : `Hogar del ${CustomEmployeeText()}`;
    return [
        isMultiCustomerUser && <Breadcrumb onClick={() => trackBreadcrumbEvent('Select a customer', trackEvent)} href="/customer-search">Select a customer</Breadcrumb>,
        (isEmployer && isMultiCustomerUser && ((!isHomePage ? (<Breadcrumb onClick={() => trackBreadcrumbEvent('Employer home', trackEvent)} href='/employer/home'>Employer home</Breadcrumb>) : (<Breadcrumb>Employer home</Breadcrumb>)))),
        (!isEmployer && isMultiCustomerUser && ((!isHomePage ? (<Breadcrumb onClick={() => trackBreadcrumbEvent(customEmployeeText, trackEvent)} href='/employee/home'>{customEmployeeText}</Breadcrumb>) : (<Breadcrumb>{customEmployeeText}</Breadcrumb>)))),
        (!isMultiCustomerUser && !isHomePage && ((isEmployer ? (<HomeBreadcrumb onClick={() => trackBreadcrumbEvent('Employer home', trackEvent)} href={'/employer/home'}/>) : (<HomeBreadcrumb onClick={() => trackBreadcrumbEvent(customEmployeeText, trackEvent)} href={'/employee/home'}/>))))
    ];
};
export const useStatusBreadcrumbs = (empNum, experience, params, location) => {
    const { trackEvent } = useTealium();
    const { viewStatus } = BreadcrumbText;
    const expPrefix = experience === Experience.EMPLOYEE ? 'employee' : 'employer';
    const parsed = queryString.parse(location?.search);
    const fromTeamView = parsed?.from === 'teamView';
    const shouldHideViewStatusBreadCrumb = window.location.href.includes('/details?from=search');
    const { t } = useTranslate();
    const from = parsed?.singleResult ? 'from=singleResult' : 'from=detailPage';
    const searchForClaimant = fromTeamView ? `/status/${expPrefix}/${encode(empNum)}/coverageDetail?from=teamView` : `/status/${expPrefix}/search?search=${parsed?.search}&searchCrit=${parsed?.searchCrit}&${from}`;
    const viewStatusTo = experience === Experience.EMPLOYER ? `/status/${expPrefix}/${encode(empNum)}/coverageDetail?${parsed?.singleResult ? 'singleResult=true&' : ''}search=${params?.search}&searchCrit=${params?.searchCrit}` : `/status/employee/7${encode(empNum)}/coveragedetail`;
    return [
        (experience === Experience.EMPLOYER && !fromTeamView) && <Breadcrumb onClick={() => trackBreadcrumbEvent('Search for claimant', trackEvent)} href={searchForClaimant}>Search for claimant</Breadcrumb>,
        (experience === Experience.EMPLOYER && fromTeamView) && <Breadcrumb onClick={() => trackBreadcrumbEvent('Team view', trackEvent)} href={'/teamview'}>Team view</Breadcrumb>,
        !shouldHideViewStatusBreadCrumb && <Breadcrumb onClick={() => trackBreadcrumbEvent(t(viewStatus), trackEvent)} href={viewStatusTo}>{t(viewStatus)}</Breadcrumb>,
    ];
};
export const trackBreadcrumbEvent = (linkName, trackEvent) => {
    trackEvent({
        event_action: TEALIUM_EVENT.EVENT_ACTION.LINK,
        event_name: linkName,
        event_type: TEALIUM_EVENT.EVENT_TYPE.BREADCRUMB,
    });
};
